export function FounderStory() {
  return (
    <div className="bg-white border border-zinc-200 rounded-sm p-8 md:p-10 mb-16">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A6E] mb-3">Who Built This</p>
      <h3 className="font-display font-bold text-xl text-zinc-950 mb-4">
        One person, five years of carrying the idea, self-funded since 2020
      </h3>
      <p className="text-zinc-600 leading-relaxed mb-4">
        BBAP was founded by Charles H. Washington — decades in recruiting and talent acquisition since 1994,
        and in the battery industry since 2008. He carried the idea for BBAP for over five years before
        building it, nights and weekends, self-funded, since 2020.
      </p>
      <p className="text-zinc-600 leading-relaxed mb-4">
        The project is grounded in a lifetime of firsthand observation of how bias actually operates — not as
        an abstract concept, but as a daily tax: knowing which stores, which hours, which spaces call for
        extra caution. He's seen the same bias show up in medical settings, and watched the same patterns he
        experienced growing up still playing out against young people today. That's the urgency behind this
        work.
      </p>
      <p className="text-zinc-600 leading-relaxed">
        BBAP is about accountability through exposure and voluntary choice — where people choose where they
        spend their time and money — not punishment, and not about pitting groups against each other. BBAP
        is pursuing fiscal sponsorship so future donations can be tax-deductible.
      </p>
      <a
        href="mailto:charlesytstuff@gmail.com?subject=BiasBuster%20%E2%80%94%20Contact%20the%20Founder"
        data-testid="about-contact-founder-link"
        className="inline-block mt-6 text-sm font-semibold text-[#1E3A6E] underline hover:text-zinc-950"
      >
        Contact the Founder
      </a>
    </div>
  );
}
